import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { INDEX_URL } from '../utils/constants';

const PublicRoute = ({ children }) => {
  const { user } = useAuth();

  if (user) {
    return <Navigate to={`${INDEX_URL}dashboard`} replace />;
  }

  return children;
};

export default PublicRoute;